<template>
<div>
  <li :class="{read : email.isRead}">{{email.subject}}</li>
</div>
</template>

<script>
export default {
  name: 'email-preview',
  props:['email'],
  data () {
    return {
    }
  },

}
</script>


<style scoped>
  .email-preview:hover{
    cursor: pointer;
  }
  .read{
        background-color: whitesmoke;
  }
  li:hover{
      cursor: pointer;
    }
  li{
    list-style-type: none;
  }
  .selcted{
    background-color: red;
  }
</style>


// WEBPACK FOOTER //
// EmailPreview.vue?f06f63da